export const GOVGR_LAYOUT_WRAPPER = "govgr-layout-wrapper";
export const GOVGR_LAYOUT_WRAPPER__FULL_HEIGHT =
  "govgr-layout-wrapper__full-height";
export const GOVGR_FULL_PAGE_BACKGROUND = "govgr-full-page-background";
export const GOVGR_LOADER_CONTAINER = "govgr-loader__container";
export const GOVGR_LOADER = "govgr-loader";
export const GOVGR_LOADER__CIRCLE = "govgr-loader__circle";
export const GOVGR_LOADER__CIRCLE__1 = "govgr-loader__circle--1";
export const GOVGR_LOADER__CIRCLE__2 = "govgr-loader__circle--2";
